import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/auth.service';

@Component({
  selector: 'app-organization',
  templateUrl: './organization.component.html',
  styleUrls: ['./organization.component.less'],
})
export class OrganizationComponent {
  constructor(private router: Router, public authService: AuthService) {}

  get clinicIsActive() {
    return this.router.url.indexOf('company') === -1;
  }
}
